import {connect} from 'react-redux';
import Umk from '../../components/umk/Umk';
import * as actions from '../../actions/umk';
import {fetchCourseBooks} from "../../reducers/CourseBooks/actions";

const mapStateToProps = ({umk, courseBooksReducer}) => ({
    group: umk.group,
    disciplineList: umk.disciplineList,
    isLoading: umk.isLoading,
    id_curriculum: umk.id_curriculum_course,
});

const mapDispatchToProps = dispatch => ({
    didMount: () => dispatch(actions.umk()),
    getCourse: id => dispatch(actions.course(id)),
    fetchCourseBooks: courseId => dispatch(fetchCourseBooks(courseId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Umk);
